import {lazy} from 'react';

/*
 * Header & Footer
 */
export const Header = lazy(() => import('../components/application/Header'));
export const Footer = lazy(() => import('../components/application/Footer'));

/*
 * Sign In & Up.
 */
const Signin = lazy(() => import('../components/application/Signin'));
export const signinPath = '/signin';
const Signup = lazy(() => import('../components/application/Signup'));
export const signupPath = '/signup';

export const authScreens = [
  {path: signinPath, view: Signin},
  {path: signupPath, view: Signup},
];

/*
 * Public Screens
 */
const Apparels = lazy(() => import('../components/products/Apparels'));
export const apparelsPath = {
  Unisex: '/t/unisex',
  Mens: '/t/mens',
  Womens: '/t/womens',
  Kids: '/t/kids',
};

const Options = lazy(() => import('../components/products/Options'));

const Product = lazy(() => import('../components/products/Product'));

const BulkOrders = lazy(() => import('../components/application/BulkOrders'));
export const bulkOrdersPath = '/bulkorders';

const Cart = lazy(() => import('../components/application/Cart'));

const Terms = lazy(() => import('../components/application/Terms'));
export const termsPath = '/terms';

const Policies = lazy(() => import('../components/application/Policies'));
export const policiesPath = '/policies';

const Support = lazy(() => import('../components/application/Support'));
export const supportPath = '/support';

const Invoice = lazy(() => import('../components/account/Invoice'));

export const publicScreens = [
  /*
   * Apparels */
  {path: '/t/:cType', view: Apparels},

  /*
   * Options Page */
  {path: '/apparels/:optionName', view: Options},
  {path: '/accessories/:optionName', view: Options},
  {path: '/decors/:optionName', view: Options},

  /*
   * Product Page */
  {path: '/product', view: Product},

  /*
   * Bulk Orders */
  {path: bulkOrdersPath, view: BulkOrders},

  /*
   * Cart */
  {path: '/cart', view: Cart},

  /*
   * Terms */
  {path: termsPath, view: Terms},
  {path: policiesPath, view: Policies},

  /*
   * Support */
  {path: supportPath, view: Support},

  {path: '/pdf', view: Invoice},
];

/*
! Protected Screens
 */
const Account = lazy(() => import('../components/account/Account'));
export const accountPath = '/account';

const Checkout = lazy(() => import('../components/account/Checkout'));

const Admin = lazy(() => import('../components/admin/Admin'));
export const adminPath = '/bm/admin/home';

const DataViewer = lazy(() => import('../components/admin/DataViewer'));
export const dataViewerPath = '/bm/admin/data/';

const PList = lazy(() => import('../components/admin/ProductsList'));
export const pListPath = '/bm/admin/plist';

const ProductsImage = lazy(() => import('../components/admin/ProductsImage'));
export const productsImagePath = '/bm/admin/pImgUploader';

export const protectedScreens = [
  {path: accountPath, view: Account},
  {path: '/checkout', view: Checkout},
  {path: adminPath, view: Admin},
  {path: dataViewerPath + ':view', view: DataViewer},
  {path: pListPath, view: PList},
  {path: productsImagePath, view: ProductsImage},
];
